import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DropdownModule } from 'primeng/dropdown';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { CompanySelectComponent } from '../shared/company-select/company-select.component';
import { CustomerSelectComponent } from '../shared/customer-select/customer-select.component';
import { AddCustomerModalComponent } from '../shared/add-customer-modal/add-customer-modal.component';
import { DateSelectComponent } from '../shared/date-select/date-select.component';
import { VatSelectComponent } from '../shared/vat-select/vat-select.component';
import { LanguageSelectComponent } from '../shared/language-select/language-select.component';
import { CurrencySelectComponent } from '../shared/currency-select/currency-select.component';
import { ProductSelectComponent } from '../shared/product-select/product-select.component';
import { AddProductComponent } from '../shared/add-product-modal/add-product-modal.component';
import { CashPaymentFormComponent } from '../shared/cash-payment-form/cash-payment-form.component';
import { BankTransferPaymentFormComponent } from '../shared/bank-transfer-payment-form/bank-transfer-payment-form.component';
import { CreditCardPaymentFormComponent } from '../shared/credit-card-payment-form/credit-card-payment-form.component';
import { CheckPaymentFormComponent } from '../shared/check-payment-form/check-payment-form.component';
import { DeductionPaymentFormComponent } from '../shared/deduction-payment-form/deduction-payment-form.component';
import { DocumentComponent } from './document.component';
import { DocumentHeadComponent } from './document-head/document-head.component';
import { DocumentLinesComponent } from './document-lines/document-lines.component';
import { DocumentLineComponent } from './document-line/document-line.component';
import { DocumentPaymentsComponent } from './document-payments/document-payments.component';

@NgModule({
	declarations: [
		DocumentComponent,
		DocumentHeadComponent,
		CompanySelectComponent,
		CustomerSelectComponent,
		AddCustomerModalComponent,
		DateSelectComponent,
		VatSelectComponent,
		LanguageSelectComponent,
		CurrencySelectComponent,
		DocumentLinesComponent,
		DocumentLineComponent,
		AddProductComponent,
		ProductSelectComponent,
		CashPaymentFormComponent,
		BankTransferPaymentFormComponent,
		CreditCardPaymentFormComponent,
		CheckPaymentFormComponent,
		DeductionPaymentFormComponent,
		DocumentPaymentsComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgSelectModule,
		TranslateModule,
		NgxSpinnerModule,
		DropdownModule,
		CardModule,
		DialogModule,
		ToastModule,
		InputNumberModule,
		InputTextModule,
		ButtonModule,
		CalendarModule,
		SelectButtonModule,
		ToggleButtonModule,
		CheckboxModule,
		TableModule,
		InputTextareaModule,
		TooltipModule
	],
	providers: [
		DatePipe
	],
	exports: [
		DocumentComponent,
		AddCustomerModalComponent,
		AddProductComponent,
	]
})
export class DocumentModule { }
